import {Link} from 'react-router-dom';
import React/*, { Component }*/ from 'react';
//import ReactDOM from 'react-dom';
import {useracc, postApi, putApi} from '../utils/functions';
//import { cookie, login } from '../utils/protectedroutes';
//import axios from 'axios';
import EventEmitter from '../utils/emmiter';


import {UserContext} from '../utils/usercontext';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Modal from 'react-bootstrap/Modal';

import './css/recover.css';

export default class Recover extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
		let key = '';
		let url = window.location.pathname.split('/');
    this.state = {
      display: 'none',
			email: '',
			key: url[2]?url[2]:'', //this.props.match.params.key,
			error: '',
			passwordnew: '',
			passwordrpt: '',
			errpassword: '',
			vpassword: null,
			vpasswordnew: null,
			vpasswordrpt: null,
			disable: false,
			changed: false,
    };
    this.handleChange = this.handleChange.bind(this);
		this.processPassword = this.processPassword.bind(this);
		this.processDetails = this.processDetails.bind(this);
		this.processDetails2 = this.processDetails2.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		
		document.title = "Recover Account - Mix365 Radio";

		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );

		EventEmitter.emit('/client', {data: 'no value'});

		if( this.state.key?.length > 0 ) {
			var params = new URLSearchParams();
			params.append('key', this.state.key);
			const x = await postApi('/api/v2/recover/key', params);
			if( x.status === 200 ) {
				this.setState({display: 'password'});
			} else {
				//this.props.history.push('/recover');
				window.location.pathname = 'recover';
			}
		}
	}

	recoverUsername = async(e) => {
		e.preventDefault();
		if( document.getElementById("email").value === null || document.getElementById("email").value === '' ) return;
    const params = new URLSearchParams();
    params.append('action', 'username');
		params.append('email', document.getElementById("email").value);
		const x = await postApi('/api/v2/recover', params);

		if( x.status===200 ) this.setState({display: 'email', email: document.getElementById("email").value});

	}

	recoverPassword = async(e) => {
		e.preventDefault();
		if( document.getElementById("email").value === null || document.getElementById("email").value === '' ) return;
    const params = new URLSearchParams();
    params.append('action', 'password');
		params.append('email', document.getElementById("email").value);
		const x = await postApi('/api/v2/recover', params);
		if( x.status===200 ) this.setState({display: 'email', email: document.getElementById("email").value});
		
	}

	login = async(e) => {
		e.preventDefault();
		this.props.history.push('/login');
	}

	reset = async(e) => {
		e.preventDefault();
		this.setState({display: '', email: ''});
	}


	handleChange(event) {
		//var isChecked = event.target.checked;
		var item = event.target.value;
		if( event.target.name === "passwordnew" ) {
			const decimal = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,40}$/;
			this.setState({passwordnew: item, vpasswordnew: (this.state.password !== item && decimal.test(String(item))),vpasswordrpt: (this.state.passwordrpt.length > 0 && this.state.passwordrpt === item?true:false)});
		}
		if( event.target.name === "passwordrpt" ) {
			//if( this.state.password.length > 0 && this.state.password === item )
			this.setState({passwordrpt: item, vpasswordrpt: (this.state.passwordnew.length > 0 && this.state.passwordnew === item?true:false)});
		}
	}


	processPassword() {
		if( this.state.passwordnew.length > 0 && this.state.passwordrpt.length > 0 ) {
			var n = this.state.passwordnew.localeCompare(this.state.passwordrpt);
			if( n === 0 )
				this.setState({errpassword: ''});
			else
				this.setState({errpassword: '* Password\'s do not match'});
		}
	}

	async processDetails(event) {
		event.preventDefault();
		this.setState({disable: true, errpassword: ''}, async () => {
			await this.processDetails2(event);
			this.setState({disable: false});
		});
	}
	async processDetails2(event) {
		
		//---- Register account
		const params = new URLSearchParams();
		params.append('key', this.state.key);
		params.append('passwordnew', this.state.passwordnew);
		params.append('passwordrpt', this.state.passwordrpt);
		const x = await putApi('/api/v2/recover', params);
		if( x.status === 200 ) {
			this.setState({error: '', changed: true});
		} else {
			this.setState({error: x.data.message});
		}

	}

	render() {
		return (
			<>
				<div className="website-background"></div>
				<Container>
					<Row>
						<Col className="text-center pt-5 text-vcenter">
							<div>
								<img  src="/images/365_Logo.png" alt="Mix365 Logo" width="250" /><br />
								<span className="recover-title">Recover your Mix365 Account</span>
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<br />{this.state.display==='none'&&
								<>
									<p>To recover your Mix365 account, please enter your email address followed by either selecting forgot username or forgot password</p>
									<Form id="contact-form" onSubmit={(e)=>{e.preventDefault()}}>
										<InputGroup className="mb-3">
											<FormControl name="email" id="email" required placeholder="Email Address" aria-label="Email Address" aria-describedby="basic-addon1" />
										</InputGroup>
										<Button size="sm" onClick={this.recoverUsername}>Forgot Username</Button>&nbsp;&nbsp;
										<Button size="sm" onClick={this.recoverPassword}>Forgot Password</Button>
									</Form>
								</>
							}
							{this.state.display==='email' &&
								<>
									<p>An email has been sent to the following address where you will find information on your username or to reset your password</p>
									<p>{this.state.email}</p>
									<p>Please allow upto a few minutes for the email to arrive and also check your spam folder.</p>
								</>
							}
							{this.state.display==='password' &&
								<>
									<p>Please create a new password and select change password to change your password</p>
									<Form id="contact-form" onSubmit={(e)=>this.processDetails(e)}>

										<InputGroup className="mb-2">
											<FormControl type="password" name="passwordnew" id="passwordnew" onChange={this.handleChange} value={this.state.passwordnew} placeholder="New Password" aria-label="New Password" aria-describedby="basic-addon1" required />
											<InputGroup.Text className="m-0 p-1" style={{background: 'rgba(144,144,144,0.07)', border: 'none'}}>
												{this.state.passwordnew.length > 0 &&
													<>
														{this.state.vpasswordnew ? <i className="fa fa-check" style={{color: '#d71362'}} /> : <i className="fa fa-exclamation" style={{color: '#d71362'}} /> }
													</>
												}
											</InputGroup.Text>
										</InputGroup>

										<InputGroup className="mb-2">
											<FormControl type="password" name="passwordrpt" id="passwordrpt" onChange={this.handleChange} value={this.state.passwordrpt} placeholder="Repeat Password" aria-label="Repeat Password" aria-describedby="basic-addon1" required />
											<InputGroup.Text className="m-0 p-1" style={{background: 'rgba(144,144,144,0.07)', border: 'none'}}>{this.state.vpasswordnew&&this.state.vpasswordrpt&&<i className="fa fa-check" style={{color: '#d71362'}} />}</InputGroup.Text>
										</InputGroup>
										
										<Button size="sm" disabled={this.state.disable} type="submit">Change Password</Button>{this.state.error.length>0&&<> {this.state.error}</>}{this.state.changed&&<span className="text-white">&nbsp;&nbsp;<i className="fa fa-check" style={{color: '#00ff00'}} /> Password changed - <Link to='/login'>Continue to login</Link></span>}
											
									</Form>
								</>
							}
						</Col>
					</Row>
				</Container>
			</>
		);
	}
}